import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import Server from '../../../functions/server';
import $ from "jquery";

class Model extends React.Component {

  state = {
    allexecutive: [],
    selectedExecutive: ''
  }

  componentDidMount() {
    this.getCustomerType();
  }

  getCustomerType() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Executive!!!',
      menucontrol: false
    });
    let data1 = {};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'menucontrol/getcustomertypes.php',
      success: function(data)
      {
        try {
          data = JSON.parse(data);
          context.setCustomerType(data);
        } catch (e) {

        }

      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!')
      }
    });
  }

  setCustomerType(data) {
    let items = [];
    items.push({key: 'All', text: 'All', value: 'All'});
    data.map((y) => {
      items.push({key: y.id+'->'+y.type_name, text: y.id+'->'+y.type_name, value: y.type_name});
    });
    this.setState({
      allType: items,
      allcustomertype: data,
    });
  }

  type = (f, { value }) => {
    this.props.update('type', value, this.state.allcustomertype);
    this.setState({ selectedType: value });
  }

  dataClear() {
    this.setState({
      selectedType: ''
    });
  }

  render() {
    return (
      <div>
        <Dropdown placeholder='Customer Type'
         fluid search selection onChange={this.type} style={{fontSize: 14}}
         options={this.state.allType} value={this.state.selectedType} />
      </div>
    );
  }
}

export default Model;
